module.exports = __webpack_public_path__ + "img/accessories_store.7ec3da98.webp";